import type { Translations } from './en';

export const fr: Translations = {
  common: {
    myTrips: 'Mes Voyages',
    settings: 'Parametres',
    signIn: 'Connexion',
    signOut: 'Deconnexion',
    signedIn: 'Connecte',
    account: 'Compte',
    email: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    back: 'Retour',
    close: 'Fermer',
    copy: 'Copier',
    view: 'Voir',
    navigate: 'Itineraire',
    copiedToClipboard: 'Copie dans le presse-papiers!',
    explore: 'Explorer',
    showMore: 'Voir plus',
    showLess: 'Voir moins',
    coachInstantSave: 'Appuyez pour enregistrer ce lieu dans votre voyage',
    share: 'Partager',
    updateAvailableTitle: 'Nouvelle version disponible',
    updateAvailableBody: 'Actualisez pour charger la dernière version de TripBoom. Vos modifications non enregistrées peuvent être perdues.',
    refresh: 'Actualiser',
  },

  input: {
    interestedIn: 'Je cherche...',
    tagline: 'Votre ville, votre temps, a votre facon.',
    whereAreYou: 'Ou etes-vous?',
    locationPlaceholder: 'Ville ou quartier...',
    pleaseEnterLocation: 'Veuillez entrer un lieu',
    useMyCurrentLocation: 'Utiliser ma position actuelle',
    locationErrorRetry: 'Réessayer',
    locationErrorEnterManually: 'Ou saisir manuellement',
    howLong: 'Combien de temps avez-vous?',
    howGettingAround: 'Comment vous déplacez-vous?',
    imFeeling: 'Je me sens...',
    pleaseSelectVibe: 'Veuillez selectionner au moins une ambiance',
    findMyAdventure: 'Trouver mon aventure',
    placesFiltered: '{count} lieu{s} filtré{s} - pas ouvert maintenant',
    includeClosedPlaces: 'Inclure les lieux fermés',
  },

  share: {
    title: 'Partager TripBoom',
    message: 'Cette appli m\u2019a organis\u00E9 toute ma journ\u00E9e en 10 secondes \u2014 restos, bars, activit\u00E9s. Teste \uD83D\uDC47',
    copyLink: 'Copier le lien',
    copied: 'Copi\u00E9 !',
    shareOn: 'Partager sur',
    twitter: 'X',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    email: 'E-mail',
    shareWithFriendTitle: 'Partager avec un ami',
    earnSubtitle: "Gagnez +2 recherches Intérêt et +2 recherches AI High lorsqu'ils s'inscrivent — ou demandez-leur de scanner le QR.",
    scanSubtitle: 'Scannez pour ouvrir TripBoom sur un autre appareil',
    shareNow: 'Partager maintenant',
    shareViaQrAria: 'Appuyez pour partager TripBoom',
    shareMessage: 'Essayez TripBoom — votre concierge de voyage IA. Utilisez mon lien ou scannez le QR : {url}',
  },

  time: {
    '1-2-hrs': '1-2 h',
    'half-day': 'Demi-journée',
    'full-day': 'Journée entière',
    '2-3-days': '2-3 jours',
  },

  transport: {
    walking: 'A pied',
    transit: 'Transports',
    taxi: 'Taxi/Voiture',
  },

  vibes: {
    hungry: 'Affamé',
    adventurous: 'Aventureux',
    'must-sees': 'Incontournable',
    'feeling-lucky': 'Au hasard',
    popular: 'Populaire',
    'hidden-gems': 'Perle cachée',
  },

  travel: {
    nearby: 'À proximité',
    rightHere: 'Juste ici',
    minWalk: '{n} min à pied',
    minTransit: '~{n} min en transports',
    minDrive: '~{n} min en voiture',
    mins: '{n} min',
    hrMins: '{h} h {m} min',
    localSpot: 'Adresse locale',
  },

  results: {
    placesFound: '{count} recommandations',
    findMorePlaces: 'Trouver plus de lieux',
    searchingWiderArea: 'Recherche dans une zone plus large...',
    placesSelected: '{count} lieu{s} selectionne{s}',
    saveTrip: 'Enregistrer le voyage',
    viewTrip: 'Voir le voyage',
    saving: 'Enregistrement...',
    saved: 'Enregistré',
    iWannaGo: 'Je veux y aller!',
    address: 'Adresse',
    hoursToday: "Horaires d'aujourd'hui",
    visitWebsite: 'Visiter le site web',
    copyHookLabel: 'Notes',
    copyTravelLabel: 'Trajet',
    copyMapsLabel: 'Google Maps',
    showingFiltered: '{filtered} sur {total} affiches',
    showingAll: 'Tout afficher',
    offlineRankingBanner: "IA indisponible — classé par note, distance et horaires d'ouverture.",
  },

  loadingStages: {
    checkingLocation: 'Verification du lieu',
    checkingLocationNamed: 'Verification de {name}',
    discoveringPlaces: 'Decouverte des lieux',
    searchesComplete: '{completed}/{total} recherches terminees',
    searchingCustomVibe: 'Recherche de vibe personnalisee...',
    mergingResults: 'Fusion des resultats...',
    deepSearching: 'Recherche approfondie de perles rares',
    findingMore: 'Recherche de plus d\'options',
    sortingByRating: 'Tri par note et distance',
    aiMatchingVibes: 'IA en correspondance de vibes',
    aiAnalysing: 'IA analyse vos options',
    sendingToAi: 'Envoi a l\'IA...',
    processingResponse: 'Traitement de la reponse...',
    filteringResults: 'Filtrage des resultats...',
    analysedEliminated: '{analysed} analyses, {eliminated} elimines',
  },

  poi: {
    moreLikeThis: 'Plus comme ca',
    lessLikeThis: 'Moins comme ca',
    moreLikeThisConfirm: 'Plus comme ca',
    lessLikeThisConfirm: 'Moins comme ca',
    cleared: 'Efface',
    open: 'Ouvert',
    closed: 'Ferme',
    likelyOpen: 'Probablement ouvert',
    likelyClosed: 'Probablement ferme',
    easy: 'Facile',
    doable: 'Faisable',
    far: 'Loin',
    travelTimeEstimate: 'Estimation basee sur la distance — le temps reel peut varier',
    travelTimeGoogle: 'Temps de trajet Google Maps',
    foundOnTripBoom: 'Trouve sur TripBoom, votre concierge de voyage IA — tripboom.app',
  },

  cancel: {
    takingABreak: 'Une pause ?',
    pauseDescription: 'Mettez en pause au lieu d\'annuler — votre profil de gout et vos voyages sont en securite.',
    proActiveUntil: 'Pro actif jusqu\'au {date}',
    pauseMonths: 'Pause {count} mois',
    pauseMonthsPlural: 'Pause {count} mois',
    resumesOn: 'Reprend le {date}',
    resumeAnytime: 'Reprenez quand vous voulez',
    pauseIndefinitely: 'Pause indefinie',
    resumeWhenReady: 'Reprenez quand vous etes pret',
    resumeFromSettings: 'Vous pouvez reprendre a tout moment depuis les Parametres. Vos donnees sont toujours conservees.',
    cancelInstead: 'Annuler l\'abonnement plutot',
    confirmTitle: 'Annuler Pro ?',
    confirmBody: "Vous gardez Pro jusqu'au {date}, puis votre compte repasse au plan gratuit. Vos voyages enregistrés et votre profil de goûts sont conservés.",
    confirmBodyNoDate: 'Votre compte repasse au plan gratuit. Vos voyages enregistrés et votre profil de goûts sont conservés.',
    keepPro: 'Garder Pro',
    confirmCancel: 'Annuler Pro',
  },

  installBanner: {
    addToHomeScreen: 'Ajouter a l\'ecran d\'accueil',
    fileToDock: 'Ajouter au Dock',
    bestExperience: 'meilleure experience',
    install: 'Installer',
    dismiss: 'Fermer',
  },

  loading: {
    messages: [
      'Recherche a proximite...',
      'Verification des horaires...',
      'Filtrage par distance...',
      'Verification des notes...',
      'Recherche de perles rares...',
      'Correspondance des vibes...',
      'Classement des resultats...',
      'On demande aux locaux...',
      'On filtre les pieges a touristes...',
      'On trouve les bonnes adresses...',
      'Presque fini...',
    ],
  },

  settings: {
    title: 'Parametres',
    aiMode: 'Support IA',
    aiModeDescription: "Utiliser l'IA pour prioriser, enrichir et decrire vos resultats",
    aiOffNotice: "L'IA est desactivee. Les resultats seront tries par note et distance. Les descriptions utiliseront uniquement les donnees Google.",
    aiLevelPrompt: "Choisissez votre niveau de support IA :",
    aiLevels: {
      off: 'Desactive',
      low: 'Bas',
      medium: 'Moyen',
      high: 'Eleve',
    },
    aiLevelDescriptions: {
      low: 'Correspondance vibes rapide, tri basique',
      medium: 'Temps de trajet, scores pratiques',
      high: 'Recherche élargie, goûts personnalisés',
    },
    showOnlyOpenPlaces: 'Afficher uniquement les lieux ouverts',
    filterClosedPlaces: 'Filtrer les lieux fermés pour les créneaux courts',
    minimumStarRating: 'Note minimale',
    onlyShowRatingOrHigher: 'Afficher uniquement les lieux avec cette note ou plus',
    any: 'Tous',
    searchDistance: 'Distance de recherche',
    adjustSearchDistance: 'Ajustez la distance de recherche pour chaque combinaison transport/temps.',
    placeCategories: 'Catégories de lieux',
    categoriesUsedWhenAIFails: "Les categories sont utilisees quand l'IA ne peut pas classifier.",
    settingsSessionOnly: "Vos filtres ne durent que cette session et sont réinitialisés à l'actualisation. Connectez-vous pour les conserver.",
    settingsSavedLoggedIn: 'Les parametres ne sont sauvegardes que pour les utilisateurs connectes.',
    signInToSave: 'Connectez-vous pour sauvegarder vos voyages',
    installApp: "Installer l'application",
    installAppDescription: "Ajoutez TripBoom a votre ecran d'accueil pour un acces rapide",
    install: 'Installer',
    tripGrouping: 'Grouper les voyages par',
    tripGroupingDescription: 'Choisissez comment organiser vos voyages enregistres',
    groupByDay: 'Jour',
    groupByLocation: 'Lieu',
    filters: 'Filtres',
    upgradeToPremium: 'Passer a Pro',
    unlimitedTripsDescription: 'Sauvegardes, recherches & mode AI High illimités',
    upgrade: 'Mettre a niveau',
    premiumMember: 'Membre Pro',
    lifetimeAccess: 'Acces a vie aux fonctionnalites & sauvegardes illimitees',
    yearlyAccess: 'Acces annuel aux fonctionnalites & sauvegardes illimitees',
    appearance: 'Apparence',
    theme: 'Theme',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    themeSystem: 'Systeme',
    tasteProfile: 'Carte des Gouts',
    interactions: 'interactions',
    tripsPlanned: 'voyages planifies',
    topCategories: 'Categories principales',
    topVibes: 'Ambiances principales',
    tasteImproves: 'Vos recommandations s\'ameliorent a chaque interaction',
    topInterests: 'Centres d\'interet',
    travelStyle: 'Style de voyage',
    prefersNearby: 'Prefere le proche',
    prefersExploring: 'Aime explorer loin',
    mixedExplorer: 'Explorateur mixte',
    prefersMixed: 'Explorateur mixte',
    subscribe: 'S\'abonner',
    premiumAccess: 'S\'abonner a Pro',
    premiumSupporter: 'Membre Pro',
    monthlyAccess: 'Acces mensuel aux fonctionnalites & sauvegardes illimitees',
    getProCTA: 'Passer a Pro — Voyages et Credits illimites',
    yourBenefits: 'Vos avantages',
    yourCredits: 'Vos credits',
    freeCredits: 'Vos credits gratuits',
    freeCreditsOnReg: 'Vos credits gratuits — a l\'inscription',
    dayGroups: 'Groupes de jours',
    locationGroups: 'Groupes de lieux',
    interestSearches: 'Recherches d\'interet',
    highAiSearches: 'Recherches AI High',
    unlimited: 'Illimite',
    perMonth: '/mois',
    unlimitedInterestSearches: 'Recherches d\'interet illimitees',
    unlimitedInterestSearchesFull: 'Recherches "Ca m\'interesse..." illimitees',
    savedInterestsBenefit: 'Interets sauvegardes — personnalisez chaque recherche',
    unlimitedGroups: 'Groupes de jours/lieux illimites',
    unlockArchived: 'Debloquer les voyages archives',
    feedbackViaWebsite: 'Commentaires via le site ↗',
    privacyAndData: 'Confidentialité et données ↗',
    contactSupport: "Contacter l'assistance",
    deleteAccount: "Supprimer mon compte",
    deleteAccountTitle: "Supprimer votre compte ?",
    deleteAccountBody: "Cela supprime définitivement votre compte, vos voyages enregistrés, vos liens partagés, votre profil de goûts et vos crédits. Action irréversible.",
    deleteAccountCancel: "Garder mon compte",
    deleteAccountConfirm: "Supprimer définitivement",
    deleteAccountDeleting: "Suppression…",
    deleteAccountDone: "Votre compte et vos données ont été supprimés.",
    deleteAccountFailed: "Impossible de supprimer votre compte pour le moment. Réessayez ou écrivez à support@tripboom.app.",
    deleteAccountActiveSub: "Vous avez un abonnement payant actif. Annulez-le d'abord pour ne plus être facturé, puis supprimez votre compte.",
    deleteAccountAdmin: "Les comptes administrateur ne peuvent pas être supprimés depuis l'app.",
    pauseFrozenResume: 'Paiement gele — reprenez pour reactiver Pro',
    pauseFrozenActiveUntil: 'Paiement gele — Pro actif jusqu\'au {date}',
    pauseFrozenExpires: 'Paiement gele — Pro expire, reprend le {date}',
    pauseFrozenActiveResumes: 'Paiement gele — Pro actif jusqu\'au {date}, reprend le {resumeDate}',
    yearlyActive: 'Annuel — Actif',
    monthlyActive: 'Mensuel — Actif',
    tripPassActive: 'Pass Voyage — Actif',
    tripPassExpired: 'Pass Voyage — expire',
    tripPassDaysLeft: 'Pass Voyage — {count} jour{s} restant{s}',
    yearlyRenews: 'Annuel — renouvelle le {date}',
    monthlyRenews: 'Mensuel — renouvelle le {date}',
    tipConcierge: 'Pourboire au Concierge',
    tipConciergeDescription: 'Vous avez passe un bon moment ? Un pourboire nous aide a continuer...',
    tipButton: 'Pourboire',
    tripPassAccess: 'Pass Voyage — actif',
    tripPassLastDay: 'Trip Pass — dernier jour !',
    proPaused: 'Pro en pause',
    proEnabled: 'Pro activé',
    proSubtitleFree: 'Recherches, sauvegardes, crédits et IA illimités',
    upsellFromTripPass: 'Économisez avec un abonnement pour des crédits illimités à chaque voyage',
    upsellFromMonthly: 'Passez à l\'annuel et économisez plus de 50 %',
  },

  auth: {
    welcomeBack: 'Bon retour',
    createAccount: 'Creer un compte',
    signInDescription: 'Connectez-vous pour sauvegarder et accéder à vos voyages sur tous vos appareils',
    iHaveAccount: "J'ai un compte",
    imNewHere: 'Je suis nouveau',
    emailPlaceholder: 'vous@exemple.com',
    passwordPlaceholder: 'Entrez votre mot de passe',
    passwordMinChars: 'Au moins 6 caracteres',
    confirmPasswordPlaceholder: 'Entrez le mot de passe a nouveau',
    pleaseEnterEmail: 'Veuillez entrer votre e-mail',
    pleaseEnterPassword: 'Veuillez entrer votre mot de passe',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caracteres',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    signingIn: 'Connexion en cours...',
    creatingAccount: 'Creation du compte...',
    newHere: 'Nouveau ici?',
    createAnAccount: 'Creer un compte',
    alreadyHaveAccount: 'Vous avez deja un compte?',
    installWebApp: "Installer l'application",
    somethingWentWrong: "Quelque chose s'est mal passe",
    apiCostNote: "TripBoom utilise des API premium pour trouver vos lieux parfaits — c'est gratuit à utiliser, mais pensez a passer Pro pour nous aider avec nos couts.",
    emailSignInLink: "M'envoyer un lien de connexion",
    emailSignInLinkInstead: "M'envoyer plutôt un lien de connexion",
    signInLinkTitle: 'Lien de connexion',
    signInLinkDescription: 'Saisissez votre e-mail et nous vous enverrons un lien de connexion en un geste. Aucun mot de passe nécessaire.',
    sendSignInLink: 'Envoyer le lien de connexion',
    checkYourEmail: 'Consultez vos e-mails',
    signInLinkSentBody: "Touchez le lien de connexion reçu par e-mail pour terminer. Il fonctionne dans n'importe quel navigateur, y compris celui-ci. Vérifiez vos spams si vous ne le voyez pas.",
    signInLinkOrCodeBody: "Touchez le lien dans l'e-mail, ou saisissez le code ci-dessous. Vous utilisez l'app TripBoom installée ? Utilisez le code : les liens s'ouvrent dans votre navigateur. Vérifiez vos spams si vous ne le voyez pas.",
    signInCodeLabel: "Code de connexion",
    signInWithCode: "Se connecter avec le code",
    checkingCode: "Vérification…",
    enterCodeFromEmail: "Saisissez le code reçu par e-mail.",
    codeInvalid: "Ce code n'a pas fonctionné. Il a peut-être expiré ou déjà été utilisé ; demandez-en un nouveau.",
    forgotPassword: 'Mot de passe oublie ?',
    resetPassword: 'Reinitialiser le mot de passe',
    emailSent: 'E-mail envoye',
    resetDescription: 'Entrez votre e-mail et nous vous enverrons un lien pour reinitialiser votre mot de passe.',
    sending: 'Envoi...',
    sendResetLink: 'Envoyer le lien',
    resetLinkSent: 'Lien de reinitialisation envoye',
    checkEmailForReset: 'Consultez votre e-mail pour le lien de reinitialisation. Verifiez les spams si vous ne le voyez pas.',
    done: 'Termine',
    continueWithGoogle: 'Continuer avec Google',
    googleSignInFailed: 'Echec de la connexion Google',
    or: 'ou',
    migrationNotice: 'Les utilisateurs beta inscrits avant le {date} devront creer un nouveau compte — desole pour le desagrement !',
  },

  savedTrips: {
    title: 'Voyages enregistres',
    tripSaved: 'Voyage enregistre!',
    noSavedTrips: 'Aucun voyage enregistre',
    selectPlacesPrompt: 'Sélectionnez des lieux et enregistrez votre voyage pour les voir ici',
    backToAllTrips: 'Retour a tous les voyages',
    backToPlanning: 'Planification',
    newSearch: 'Nouvelle recherche',
    mergeTrips: 'Fusionner',
    selectTrips: 'Choisir voyages',
    merge: 'Fusionner',
    showAllTrips: 'Voir tous les voyages',
    places: 'lieux',
    deleteGroup: 'Supprimer le groupe',
    deleteGroupConfirm: 'Supprimer tous les voyages de ce groupe?',
    groupLimitReached: 'Vous avez atteint la limite gratuite. Supprimez un groupe ou mettez a niveau pour enregistrer plus de voyages.',
    trips: 'voyages',
    addToTrip: 'Ajouter au voyage',
    newSuggestions: 'Nouvelles suggestions - selectionnez pour ajouter',
  },

  itinerary: {
    title: 'Votre itineraire',
  },

  resetPassword: {
    verifying: 'Vérification de votre lien...',
    linkExpired: 'Lien expiré ou invalide',
    linkExpiredBody: "Les liens de réinitialisation expirent après 1 heure. Demandez-en un nouveau depuis l'écran de connexion.",
    backToTripBoom: 'Retour à TripBoom',
    updated: 'Mot de passe mis à jour !',
    updatedBody: 'Vous êtes maintenant connecté avec votre nouveau mot de passe.',
    goToTripBoom: 'Aller à TripBoom',
    setNew: 'Définir un nouveau mot de passe',
    setNewBody: 'Choisissez quelque chose de solide — au moins 6 caractères.',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    atLeast6: 'Au moins 6 caractères',
    repeatPassword: 'Répétez le mot de passe',
    saving: 'Enregistrement...',
    submit: 'Définir le nouveau mot de passe',
    tooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    mismatch: 'Les mots de passe ne correspondent pas',
  },

  errors: {
    noOpenPlacesFound: 'Aucun lieu ouvert trouve. {count} lieux sont actuellement fermes.',
    noPlacesFound: 'Aucun lieu trouve correspondant a vos criteres. Essayez de modifier votre recherche.',
    searchUnavailable: "Notre service de recherche est momentanément injoignable. Votre recherche n'y est pour rien ; réessayez dans un instant.",
    unableToRank: 'Impossible de classer les lieux. Veuillez reessayer.',
    genericError: 'Erreur: {message}. Veuillez reessayer ou modifier vos criteres de recherche.',
    locationNotFound: "Impossible de trouver ce lieu. Vérifiez l'orthographe et réessayez.",
    signInForInterest: 'Connectez-vous pour débloquer d\'autres recherches « Intéressé par… ». C\'est gratuit !',
    creditsExhaustedBody: "Vous avez utilisé vos crédits de recherche par intérêts pour ce mois — belle exploration ! Gagnez-en plus en partageant dans l'app, ou passez Pro pour un accès illimité.",
    dismiss: 'Fermer',
    goPro: 'Passer Pro',
  },

  payment: {
    upgradeFailed: "Cela n'a pas abouti. Rien n'a été débité ; veuillez réessayer.",
    unlockUnlimited: 'Voyages et crédits illimités',
    upgradeDescription: 'Enregistrez autant de voyages que vous voulez, organises comme vous le souhaitez',
    limitReached: 'Limite de groupes atteinte',
    dayLimitReached: 'Vous avez {current} sur {max} groupes de jours',
    locationLimitReached: 'Vous avez {current} sur {max} groupes de lieux',
    bothLimitsReached: 'Vous avez {maxDays} groupes de jours et {maxLocations} groupes de lieux',
    whatYouGet: 'Ce que vous obtenez',
    unlimitedDayGroups: 'Groupes de jours illimites',
    unlimitedLocationGroups: 'Groupes de lieux illimites',
    saveUnlimitedTrips: 'Enregistrez des voyages illimites pour toujours',
    aiHighMode: 'IA Élevé — recherches supplémentaires et meilleure correspondance des goûts',
    monthly: 'Mensuel',
    billedMonthly: 'Facture mensuellement — annulez a tout moment',
    yearly: 'Annuel',
    billedAnnually: 'Facture annuellement — annulez a tout moment',
    perMonth: '/mois',
    perYear: '/an',
    bestValue: 'MEILLEUR CHOIX',
    tripPass: 'Pass Voyage',
    tripPassDescription: '7 jours de Pro — achetez quand vous voyagez',
    oneOff: 'unique',
    whyWeCharge: 'Google nous facture a chaque fois que nous utilisons les donnees de base qui sont gratuites dans Maps. Nous ajoutons l\'IA, l\'apprentissage des gouts, la priorisation pratique et plus encore. Nous ne pouvons garder les donnees Google que quelques jours. Partager cette app avec d\'autres, et votre soutien financier, nous permet de continuer. Et on trouve ca cool.',
    upgradeNow: 'Mettre a niveau maintenant',
    processing: 'Traitement...',
    customTip: 'Pourboire au Concierge',
    customTipDescription: 'Un don pour nous aider à construire plus',
    tipNow: 'Entrez un montant ci-dessus',
    thankYou: 'Merci infiniment !',
    securePayment: 'Paiement securise',
    upgradeSuccess: 'Bienvenue dans TripBoom Pro!',
    premiumFeature: 'Pro',
    whyWeChargeTitle: 'Pourquoi TripBoom a-t-il un palier Pro ?',
    billedAnnuallyNeutral: 'Idéal pour les voyageurs fréquents',
    billedMonthlyNeutral: 'Flexible — annulez à tout moment',
    betaBannerTitle: 'Accès Bêta — toutes les fonctionnalités Pro sont gratuites',
    betaBannerBody: 'Aucun débit. Activez pour tout débloquer.',
    activateFreeBeta: 'Activer la Bêta gratuite',
    betaActivate: 'Activation instantanée — aucun paiement requis',
  },
  categories: {
    restaurant: 'restaurant',
    cafe: 'cafe',
    bakery: 'boulangerie',
    bar: 'bar',
    meal_takeaway: 'plats a emporter',
    meal_delivery: 'livraison de repas',
    fast_food_restaurant: 'restauration rapide',
    coffee_shop: 'cafe',
    tourist_attraction: 'attraction touristique',
    museum: 'musee',
    art_gallery: 'galerie d\'art',
    church: 'eglise',
    hindu_temple: 'temple hindou',
    mosque: 'mosquee',
    synagogue: 'synagogue',
    park: 'parc',
    amusement_park: 'parc d\'attractions',
    aquarium: 'aquarium',
    zoo: 'zoo',
    performing_arts_theater: 'theatre',
    cultural_center: 'centre culturel',
    national_park: 'parc national',
    campground: 'camping',
    hiking_area: 'zone de randonnee',
    marina: 'port de plaisance',
    sports_club: 'club sportif',
    sports_complex: 'complexe sportif',
    stadium: 'stade',
    ski_resort: 'station de ski',
    athletic_field: 'terrain de sport',
    bowling_alley: 'bowling',
    book_store: 'librairie',
    night_club: 'boite de nuit',
    liquor_store: 'cave a vins',
    market: 'marche',
    shopping_mall: 'centre commercial',
    casino: 'casino',
    spa: 'spa',
    movie_theater: 'cinema',
  },

  referral: {
    friendShared: 'Un ami vous a partagé TripBoom !',
    signUpNudge: 'Connectez-vous pour débloquer vos recherches gratuites — et offrir des crédits bonus à votre ami.',
    signUpFree: 'Se connecter gratuitement',
    maybeLater: 'Peut-être plus tard',
    totalsLine: '{count} amis inscrits · +{interest} Intérêt · +{deep} Approfondies',
    recentJoinersAria: 'Voir les derniers inscrits',
  },

  pin: {
    pinAria: 'Ajouter ce voyage à votre plan',
    unpinAria: 'Retirer ce voyage de votre plan',
    pinPlanLabel: 'Épingler au plan',
    pinTripToPlanLabel: 'Épingler au plan',
    pinnedLabel: 'Épinglé',
    yourPlanLabel: 'Votre plan',
    emptyHint: 'Ouvrez un voyage enregistré et appuyez sur "Épingler au plan" pour le définir comme votre plan actif. Jusqu\'à deux peuvent être épinglés à la fois.',
    emptyHintAria: 'Comment épingler un voyage',
    mergePlan: 'Fusionner le plan',
    mergePlanAria: 'Fusionner vos deux voyages épinglés en un seul plan',
  },

  toasts: {
    welcome: 'Bienvenue sur TripBoom ! Commencez à explorer',
    firstShare: 'Votre premier voyage partagé !',
    firstSaveBonus: "Bienvenue ! +5 recherches d'intérêt et 3 recherches AI High débloquées",
    saveFailed: 'Nous n\'avons pas pu enregistrer ce voyage. Réessayez.',
    renamed: 'Voyage renommé.',
    linkCopied: 'Lien copié.',
    deleteFailed: 'Suppression impossible. Veuillez réessayer.',
    renameFailed: 'Impossible de renommer ce voyage. Veuillez réessayer.',
    addPlacesFailed: "Impossible d'ajouter ces lieux. Veuillez réessayer.",
    loadFailed: 'Impossible de charger vos voyages. Affichage de la dernière version connue.',
    cancelDone: 'Abonnement annulé.',
    cancelFailed: "Impossible d'annuler l'abonnement. Veuillez réessayer.",
    pauseFailed: "Impossible de mettre l'abonnement en pause. Veuillez réessayer.",
    resumeFailed: "Impossible de reprendre l'abonnement. Veuillez réessayer.",
    refundFailed: 'Aucun résultat, et le remboursement du crédit a échoué. Veuillez contacter le support.',
    interestCreditRefunded: "Cette recherche n'a rien donné : votre crédit d'intérêt vous est rendu.",
    subscriptionExpiredTitle: 'Votre abonnement est terminé',
    subscriptionExpiredBody: 'Réabonnez-vous pour débloquer recherches, sauvegardes et IA illimitées.',
    subscriptionExpiredCTA: 'Voir les forfaits',
    dismiss: 'Ignorer',
    referralReward: "Votre ami a gagné +{interest} recherches d'intérêt et {deep} recherches AI High !",
    noAiHighCredits: 'Plus de crédits AI High — passage en Moyen',
    aiHighLeft: 'AI High ({count} restants)',
  },

  reevaluate: {
    headerButton: 'Ajuster',
    heroBannerTitle: 'Ajuster ces lieux selon votre contexte',
    heroBannerSubtitle: 'Reclassez selon votre position, votre mode de déplacement et le temps disponible',
    heroBannerCta: 'Ajuster ces lieux selon votre contexte',
    title: 'Ajuster ces lieux',
    langLabel: 'Langue :',
    subtitle: 'Reclassez ces lieux selon votre contexte — où vous êtes, comment vous vous déplacez, et combien de temps vous avez.',
    locationLabel: 'Position',
    locationOriginal: 'Originale',
    locationCurrent: 'Actuelle',
    submitButton: 'Ajuster',
    reevaluating: 'Ajustement…',
    bannerTitle: 'Ajusté pour vous',
    bannerSubtitle: 'Reclassé selon votre contexte : {transport}, {time}.',
    offlineBannerTitle: 'IA indisponible',
    offlineBannerSubtitle: "Classé par note, distance et horaires d'ouverture pour : {transport}, {time}.",
    clear: 'Réinitialiser',
    saveCta: 'Enregistrer ce voyage dans mon compte',
    currentLocationLabel: 'Votre position actuelle',
    noCoordinatesError: 'Ce voyage n\'a pas de données de localisation — essayez Position actuelle.',
    geoUnsupportedError: 'Votre navigateur ne prend pas en charge la géolocalisation.',
    geoPermissionError: 'Permission de localisation refusée. Choisissez Originale.',
    geoFailedError: 'Impossible d\'obtenir votre position. Choisissez Originale.',
    genericError: "L'ajustement a échoué. Réessayez.",
    toastSaved: 'Voyage enregistré ! Épinglez-le manuellement pour le mettre en avant.',
    toastSavedAndPinned: 'Voyage enregistré et épinglé à votre plan !',
    savedTripButtonLabel: 'Ajuster',
    savedTripButtonTitle: 'Ajuster',
    savedTripButtonAria: 'Ajuster ce voyage pour un nouveau contexte',
    savedTripBannerTitle: 'Ajusté',
    savedTripSave: 'Enregistrer comme nouveau voyage',
    savedTripSaveAria: 'Enregistrer ce voyage ajusté comme un nouveau voyage',
    savedTripDiscard: 'Annuler',
    savedTripDiscardAria: "Annuler l'ajustement et revenir à l'ordre d'origine",
  },

  sharedTrip: {
    loadingTrip: 'Chargement du voyage...',
    tripNotFound: 'Voyage introuvable',
    tripNotFoundDesc: 'Ce voyage a peut-être été supprimé ou le lien est incorrect.',
    loadFailed: 'Impossible de charger ce voyage',
    loadFailedDesc: 'Un problème est survenu pendant le chargement. Le voyage existe peut-être toujours : réessayez.',
    retry: 'Réessayer',
    placesCount: '{count} lieux · Appuyez pour explorer',
    ctaButton: 'Essayez TripBoom — c\'est gratuit',
    madeWith: 'Créé avec TripBoom, votre concierge de voyage IA',
    aboutTagline: 'Votre concierge de voyage IA. Dites-lui ce dont vous avez envie.',
    featureSearch: 'Recherche par ambiance',
    featureSearchDesc: 'Cherchez par humeur, pas par mots-clés',
    featureAI: 'Classement IA',
    featureAIDesc: 'Résultats adaptés à vos goûts',
    featureSave: 'Sauvegarder & Partager',
    featureSaveDesc: 'Créez des voyages et partagez-les comme celui-ci',
    featureFree: 'Gratuit',
    featureFreeDesc: 'Pas besoin de compte pour commencer',
    linkFeatures: 'Fonctionnalités',
    linkPricing: 'Tarifs',
    linkInstall: 'Installer',
  },
};
